export const Roles: Record<string, number> = {
    'user': 1,
    'admin' : 2,
    'superadmin' : 3,
    'user:settings' : 2
};